import { action, observable } from 'mobx';
import { fetchLLpoints } from './loyaltyUtils';
import { LLfetchError, LLpointsData, LLreward, LoyaltyState } from './loyaltyTypes';

const customerInfo = window?.getCustomerInfo && window?.getCustomerInfo();
const DEFAULT_POINT_BALANCE = customerInfo?.loyalty_points_balance || 0;
const DEFAULT_TIER = customerInfo?.loyalty_tier || 'tier1';
const email = customerInfo?.email;

export const loyaltyState = observable<LoyaltyState>({
  pointsBalance: DEFAULT_POINT_BALANCE,
  tier: DEFAULT_TIER,
  variantSelectorData: {
    reward: null,
    buttonText: 'Redeem',
  },
  isLoading: false,
});

export const setPointsBalance = action((points: number) => {
  loyaltyState.pointsBalance = points;
});
export const setTier = action((tier: string) => {
  loyaltyState.tier = tier;
});

export const getLoyaltyMetadata = async () => {
  if (email) {
    setLoyaltyIsLoadingState(true);
    const data: LLpointsData | LLfetchError = await fetchLLpoints(email);
    if (!data.hasOwnProperty('detail')) {
      setPointsBalance((data as LLpointsData).points_approved);
      setTier((data as LLpointsData).tier);
    } else {
      console.log('Error fetching loyalty metadata', { error: (data as LLfetchError).detail });
    }
    setLoyaltyIsLoadingState(false);
  }
};

export const openLoyaltyVariantSelectorModal = action((reward: LLreward, buttonText: string) => {
  loyaltyState.variantSelectorData = {
    reward,
    buttonText,
  };
});

export const closeLoyaltyVariantSelectorModal = action(() => {
  loyaltyState.variantSelectorData = {
    reward: null,
    buttonText: 'Redeem',
  };
});

export const setLoyaltyIsLoadingState = action((newValue: boolean) => {
  loyaltyState.isLoading = newValue;
});

window.addEventListener('load', getLoyaltyMetadata);
